/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Hero_TitleInputs */

const en_directory_hero_title = /** @type {(inputs: Directory_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Find the Right AI Tools, Faster.`)
};

const zh_directory_hero_title = /** @type {(inputs: Directory_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发现全球严选 AI 工具`)
};

/**
* | output |
* | --- |
* | "Find the Right AI Tools, Faster." |
*
* @param {Directory_Hero_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_hero_title = /** @type {((inputs?: Directory_Hero_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Hero_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_hero_title(inputs)
	return zh_directory_hero_title(inputs)
});
export { directory_hero_title as "directory.hero.title" }